module.exports = __webpack_public_path__ + "static/media/banner-2.6f9c57f1.jpg";